var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('slider', {
    attrs: {
      "animation": "normal",
      "auto": true,
      "interval": 5000,
      "height": "425px"
    }
  }, _vm._l((_vm.clientProp), function(item) {
    return _c('slider-item', {
      key: item.id
    }, [_c('b-container', [_c('b-row', {
      staticClass: "text-center",
      staticStyle: {
        "margin-bottom": "20px"
      },
      attrs: {
        "align-v": "center"
      }
    }, [_c('b-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('p', {
      staticClass: "sign"
    }, [_vm._v("What client say?")]), _vm._v(" "), _c('p', {
      staticClass: "separator"
    }, [_vm._v("— • —")])])], 1), _vm._v(" "), _c('b-row', {
      staticClass: "justify-content-md-center text-center"
    }, [_c('b-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "1",
        "lg": "1",
        "align-v": "center"
      }
    }, [_c('img', {
      staticClass: "profileSize",
      attrs: {
        "src": item.image
      }
    })])], 1), _vm._v(" "), _c('b-row', {
      staticClass: "text-center",
      staticStyle: {
        "margin-top": "20px"
      },
      attrs: {
        "align-v": "center"
      }
    }, [_c('b-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('p', {
      staticClass: "greetingText"
    }, [_vm._v("\"" + _vm._s(item.description) + "\"")]), _vm._v(" "), _c('p', {
      staticClass: "line"
    }, [_vm._v("—")]), _vm._v(" "), _c('p', {
      staticClass: "clientDesp"
    }, [_c('span', {
      staticClass: "clientName"
    }, [_vm._v(_vm._s(item.name))]), _c('br'), _c('span', [_vm._v(_vm._s(item.profession))])])])], 1)], 1)], 1)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc457292","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider.vue
// module id = OCke
// module chunks = 0